<template>
  <el-form ref="loginForm"
           :model="loginForm"
           :rules="fieldRules"
           label-position="left"
           label-width="0px"
           class="demo-ruleForm login-container"
  >
    <span class="tool-bar">
      <!-- 主题切换 -->
      <theme-picker style="float:right;"
                    class="theme-picker"
                    :default="themeColor"
                    @onThemeChange="onThemeChange"
      />
    </span>
    <h2 class="title"
        style="padding-left:22px;"
    >
      {{ CappName }}
    </h2>
    <div style="display:flex;justify-content: flex-end">
      <el-button type="text" @click="openFace">人脸登录</el-button>
    </div>
    <el-form-item prop="account">
      <el-input ref="account"
                v-model="loginForm.account"
                type="text"
                auto-complete="off"
                placeholder="账号"
                @keyup.native="accountEnter($event)"
      />
    </el-form-item>
    <el-form-item prop="password">
      <el-input ref="password"
                v-model="loginForm.password"
                type="password"
                auto-complete="off"
                placeholder="密码"
      />
    </el-form-item>
    <el-form-item prop="branchCode">
      <el-input ref="branchCode"
                v-model="loginForm.branchCode"
                auto-complete="off"
                placeholder="公司编号"
                @keyup.enter.native="login"
      />
    </el-form-item>
    <el-form-item v-if="loginForm.src">
      <el-col :span="12">
        <el-form-item prop="captcha">
          <el-input type="test" v-model="loginForm.captcha" auto-complete="off" placeholder="验证码, 单击图片刷新"
            style="width: 100%;" @keyup.enter.native="login">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col class="line" :span="1">&nbsp;</el-col>
      <el-col :span="11">
        <el-form-item>
          <img style="width: 100%;" class="pointer" :src="loginForm.src" @click="getCaptcha">
        </el-form-item>
      </el-col>
    </el-form-item>
    <el-form-item style="width:100%;">
      <el-button type="primary"
                 style="width:48%;"
                 @click.native.prevent="reset"
      >
        重 置
      </el-button>
      <el-button type="primary"
                 style="width:48%;"
                 :loading="loading"
                 @click.native.prevent="login"
      >
        登 录
      </el-button>
    </el-form-item>
    <el-dialog v-dialogDrag width="500px" :visible.sync="dialogVisibleface" :before-close="close" :show-close="false" @open="facekey = true">
      <WebRTCFaceRecognition ref="WebRTCFaceRecognition" v-if="facekey" @update="submit"></WebRTCFaceRecognition>
    </el-dialog>
    <el-dialog v-dialog-drag width="60%" :visible.sync="dialogVisibleHelp">
      <img style="width:914px;margin-top:50px" v-if="jtimg" src="../../static/img/help.png" alt="">
      <img style="width:914px;margin-top:50px" v-else src="../../static/img/help.gif" alt="">
      <span slot="footer" class="dialog-footer">
        <el-button @click="jtimg = true">取消动画</el-button>
        <el-button type="primary" @click="jtimg = false">查看动画</el-button>
      </span>
    </el-dialog>
  </el-form>
</template>

<script>
import { mapState } from "vuex";
import Cookies from "js-cookie";
import ThemePicker from "@/components/ThemePicker";
import WebRTCFaceRecognition from "@/components/faceapi/WebRTCFaceRecognition"
export default {
  name: "SubsidiaryLogin",
  components: {
    ThemePicker,
    WebRTCFaceRecognition
  },
  data() {
    return {
      jtimg:true,
      dialogVisibleHelp:false,
      facekey:false,
      dialogVisibleface:false,
      loading: false,
      loginForm: {
        account: "",
        password: "",
        usertype: "1",
        captcha:'',
        src: '',
        branchCode:''
      },
      fieldRules: {
        account: [
          { required: true, message: "请输入账号", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      checked: true
    };
  },
  computed: {
    ...mapState({
      themeColor: state => state.app.themeColor
    })
  },
  provide(){
    return {
      close:this.close
    }
  },
  mounted() {
    this.$refs.account.focus();
    this.loginForm.branchCode = this.$route.params.id?this.$route.params.id:''
  },
  methods: {
    openFace(){
      this.dialogVisibleface = true;
      if(!navigator.mediaDevices){
        this.dialogVisibleHelp = true
      }
    },
    // 人脸采集
    submit(src){
      sessionStorage.setItem('tkn','eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsInBvc3RJZCI6MSwiZXhwIjo0NjExNjg3NjA0ODM4MDk3LCJjcmVhdGVkIjoxNTg2NDEwNzA1ODMwLCJhdXRob3JpdGllcyI6W119.RBdNZUn7Eiu6l_7Rmm_CU7iaD7pIEYK9FgxxzAQ_iKDNk8gCxSf3MwAkSIGZS256q5vl3PqmDrWxh_SaPLulfQ')
      // Cookies.set("token", 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsInBvc3RJZCI6MSwiZXhwIjo0NjExNjg3NjA0ODM4MDk3LCJjcmVhdGVkIjoxNTg2NDEwNzA1ODMwLCJhdXRob3JpdGllcyI6W119.RBdNZUn7Eiu6l_7Rmm_CU7iaD7pIEYK9FgxxzAQ_iKDNk8gCxSf3MwAkSIGZS256q5vl3PqmDrWxh_SaPLulfQ');
      this.axios({
        url:this.zuul+'/xyj-aiauto/w/sysUserFace/compareFaceBASE64/1',
        method:'post',
        params:{
          fileBase64:src
        }
      }).then(res => {
        this.facelogin(res.data.faceurl,res.data.regId,res.data.regtype);
      }).catch(err => {
        this.facekey = false
        this.$message.error(err.message)
        setTimeout(() => {
          this.facekey = true
        },200)
      })
    },
    // 业务库登录
    facelogin(url,id,memo){
      this.axios({
        url:this.zuul+'/xyj-admin/r/facelogin',
        method:'post',
        params:{
          faceurl:url,
          id:id,
          type:memo
        }
      }).then(res => {
        // Cookies.remove('token');
        sessionStorage.removeItem('tkn')
        if (res.data) {
          // Cookies.set("token", res.data.token.token); // 放置token到Cookie
          sessionStorage.setItem('tkn',res.data.token.token)
          sessionStorage.setItem("userid", res.data.loginInfo.userid);
          sessionStorage.setItem("user", res.data.loginInfo.username); // 保存用户到本地会话
          sessionStorage.setItem("createTime", res.data.loginInfo.user.createTime); // 保存用户注册时间到本地会话
          sessionStorage.setItem("branchCode", res.data.branchCode); // 保存用户到本地会话
          sessionStorage.setItem("branchId", res.data.branchId);
          setTimeout(() => {
            this.$addStorageEvent(2, "userid", res.data.loginInfo.userid);
          },800)
          this.$store.commit("menuRouteLoaded", false); // 要求重新加载导航菜单
          this.$router.push("/");  // 登录成功，跳转到主页
          this.loading = false;
          this.getControl();
        }
        if (res.data && !res.data.token.token) {
          this.$message({
            type: "info",
            message: "用户会话信息已过期，请刷新后重新登录"
          });
        }
        if (res.code !== 200) {
          this.$message.error(res.msg);
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    close(){
      // 关闭摄像头
      if(navigator.mediaDevices){
        this.$refs.WebRTCFaceRecognition.fnClose()
      }
      this.facekey = false
      this.dialogVisibleface = false
    },
    /**
     *宋建国：2019/7/30 9:25
     *描述：当输入账号回车时光标移动到密码位置
     */
    accountEnter(event) {
      if(event.keyCode != 13){//除回车键外
          //标记当前事件函数的时间戳
          this.lastTimeStamp = event.timeStamp;
          setTimeout(() => {
              //1s后比较二者是否还相同（因为只要还有事件触发，lastTimeStamp就会被改写，不再是当前事件函数的时间戳）
              if(this.lastTimeStamp == event.timeStamp){
                if(this.loginForm.account){
                  this.getCaptcha()
                }
              }
          }, 1000);
      }
      if (event.keyCode == 13 && this.loginForm.account.length > 0) {
        this.$refs.password.focus();
      }
    },
    // 聊天是否展示请求判断
    getControl() {
      this.jquery.ajax({
        headers: { "token": sessionStorage.getItem('tkn'), "Content-Type": "application/json;charset=UTF-8" },
        url: this.zuul + "/xyj-admin/r/sysProject/chatStat",
        type: "get",
        async: false,
        processData: false,
        success: function(data) {
          sessionStorage.setItem('chat_funciton', data.msg);
        }
      });
    },
    // 获取验证码
    getCaptcha(){
      this.axios({
        url:this.zuul+'/xyj-admin/w/getPcCaptcha',
        method:'get',
        params:{
          userName:this.loginForm.account
        }
      }).then(res => {
        if(res){
          this.loginForm.src = res.msg
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    login() {
      this.loading = true;
      const userInfo = { 
        account: this.loginForm.account, 
        password: this.loginForm.password, 
        usertype: "1",
        captcha:this.loginForm.captcha,
        branchCode:this.loginForm.branchCode
      };
      this.$api.login.login(userInfo).then((res) => {
        if (res.data) {
          // Cookies.set("token", res.data.token.token); // 放置token到Cookie
          sessionStorage.setItem('tkn',res.data.token.token)
          sessionStorage.setItem("userid", res.data.loginInfo.userid);
          sessionStorage.setItem("user", userInfo.account); // 保存用户到本地会话
          sessionStorage.setItem("chatid", res.data.chatid); // 保存聊天ID到本地会话
          sessionStorage.setItem("createTime", res.data.loginInfo.user.createTime); // 保存用户注册时间到本地会话
          sessionStorage.setItem("branchCode", res.data.branchCode); // 保存用户到本地会话
          sessionStorage.setItem("branchId", res.data.branchId);
          setTimeout(() => {
            this.$addStorageEvent(2, "userid", res.data.loginInfo.userid);
          },800)
          this.$store.commit("menuRouteLoaded", false); // 要求重新加载导航菜单
          this.$router.push("/");  // 登录成功，跳转到主页
          this.loading = false;
          this.getControl();
        }
        if (res.data && !res.data.token.token) {
          this.$message({
            type: "info",
            message: "用户会话信息已过期，请刷新后重新登录"
          });
        }
        if (res.code !== 200) {
          this.$message.error(res.msg);
        }
      }).catch((res) => {
        this.$message({
          message: res.message,
          type: "error"
        });
        this.loading = false;
        this.getCaptcha()
      });
    },
    reset() {
      this.$refs.loginForm.resetFields();
    },
    // 切换主题
    onThemeChange: function(themeColor) {
      this.$store.commit("setThemeColor", themeColor);
    }
  }
};
</script>

<style lang="scss" scoped>
  .login-container {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 100px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
      margin: 0px auto 15px auto;
      // margin: 0px auto 30px auto;
      text-align: center;
      color: #505458;
    }
    .remember {
      margin: 0px 0px 35px 0px;
    }
  }
  .login-container /deep/ .el-dialog__header,.login-container /deep/ .el-dialog__body{
    padding:0;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/SubsidiaryLogin.vue